export const uomOptions = ["EA", "M", "M2", "M3", "KG", "LOT", "HR", "SET"];

export const branchOptions = [
  { id: 1, name: "جدة" },
  { id: 2, name: "منطقة الرياض" },
];